import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "./Card";
import InfoModal from "./InfoModal";
import HowToModal from "./HowToModal";
import { API_BASE_URL } from "../../../config/api";
import useInfinitePaginated, { mergeBuckets } from "../../../hooks/useInfinitePaginated";
import InfiniteScrollFooter from "../../../Components/InfiniteScrollFooter";

const cards = [
  {
    certificateType: "phase1",
    title: "گواهی پایان مرحله ارزیابی",
    infoText: (
      <p>
        این مدرک، نخستین تاییدیه رسمی بر مهارت شماست. دریافت این گواهی یعنی شما
        از فیلتر اولیه عبور کرده‌اید، مدیریت ریسک را می‌شناسید و انضباط لازم
        برای ورود به مراحل پیشرفته‌تر را دارید. <br />
        کاربرد: نشان‌دهنده پتانسیل بالای شما برای تبدیل شدن به یک معامله‌گر
        حرفه‌ای و جواز ورود به مرحله دوم ارزیابی(و سپس دریافت حساب حقیقی) است.
      </p>
    ),
    howToText: (
      <p>
        کافیست در مدت زمان تعیین شده، به «تارگت سود» مرحله اول برسید و در عین
        حال، هیچ‌یک از قوانین «حد ضرر روزانه» و «حد ضرر کل» را نقض نکنید. به محض
        عبور موفق از این مرحله، این گواهی صادر می‌شود.
        <br />
        (برای اطلاع کامل از قوانین معاملاتی به صفحه‌ی مربوطه مراجعه نمایید.)
      </p>
    ),
  },
  {
    certificateType: "phase2",
    title: "گواهی‌نامه «معامله‌گر رسمی» ",
    infoText: (
      <p>
        این ارزشمندترین مدرک ورودی شماست. این گواهی یعنی دوران «آزمون و خطا»
        تمام شده است. شما تمام مراحل ارزیابی را با موفقیت پشت سر گذاشته‌اید و
        اکنون به عنوان یک معامله‌گر تامین سرمایه شده در حساب اصلی کوژیتوفاند
        فعالیت می‌کنید.
        <br />
        کاربرد: این سند اثبات می‌کند که شما یک تریدر حرفه‌ای، منضبط و دارای
        استراتژی سودده هستید که صلاحیت مدیریت سرمایه‌های واقعی را دارد.
      </p>
    ),
    howToText: (
      <p>
        کافیست در مدت زمان تعیین شده، به «تارگت سود» مرحله دوم برسید و در عین
        حال، هیچ‌یک از قوانین «حد ضرر روزانه» و «حد ضرر کل» را نقض نکنید. به محض
        عبور موفق از این مرحله، این گواهی که شروع دوران حرفه‌ای شما را اعلام
        می‌کند، صادر می‌شود.
        <br />
        (برای اطلاع کامل از قوانین معاملاتی به صفحه‌ی مربوطه مراجعه نمایید.)
      </p>
    ),
  },
  {
    certificateType: "payout1",
    title: "گواهی اولین برداشت سود ",
    infoText: (<p>گواهی یک نقطه عطف حیاتی است؛ زیرا ثابت می‌کند شما نه تنها چالش را پاس کرده‌اید، بلکه در بازار واقعی هم توانسته‌اید سود خلق کنید و آن را برداشت نمایید.<br/>کاربرد: نماد تغییر وضعیت شما از یک «معامله‌گر آزمایشی» به یک «معامله‌گر درآمدزا».</p>),
    howToText: "در حساب حقیقی (Funded) معامله کنید و به اولین سود قابل برداشت برسید. پس از ثبت درخواست و واریز اولین سهم سود به حساب یا کیف پول کریپتوی شما، این گواهی به افتخار شما صادر می‌گردد.",
  },
  {
    certificateType: "payout",
    title: "گواهی‌نامه برداشت سود ",
    infoText: (
      <p>
        این گواهی برای هر بار برداشت سود (دوم به بعد) صادر می‌شود و حکم «فیش
        دریافتی» معتبر شما را دارد. در این سند جزئیات دقیق عملکرد مالی شما، سهم
        سودتان و بازگشت هزینه‌ها ثبت می‌شود.
        <br />
        کاربرد: این مدرک برای ساختن رزومه مالی بسیار حیاتی است و استمرار سودآوری
        شما را در طول زمان به سرمایه‌گذاران نشان می‌دهد.
      </p>
    ),
    howToText:
      "این گواهی پس از هر بار تقسیم سود موفق صادر می‌شود. کافیست طبق دوره زمانی مشخص شده (مثلاً دو هفته یک‌بار) سود کسب کنید و درخواست برداشت دهید.",
  },
  {
    certificateType: "payout10k",
    title: "نشان افتخار ۱۰,۰۰۰ دلار برداشت ",
    infoText: (
      <p>
        این یک گواهی معمولی نیست؛ بلکه ورود شما به باشگاه نخبگان بازار را جشن
        می‌گیرد. دریافت این نشان یعنی سودآوری شما اتفاقی نبوده و توانسته‌اید در
        بلندمدت، مجموع برداشتی‌های خود را به عدد قابل توجه ۱۰,۰۰۰ دلار برسانید.
        <br />
        کاربرد: نشان‌دهنده «ثبات» و «دوام» شما در بازار است که دو ویژگی کمیاب در
        دنیای ترید هستند.
      </p>
    ),
    howToText:
      "به سودسازی مستمر ادامه دهید. سیستم به صورت خودکار مجموع تمام برداشت‌های شما را محاسبه می‌کند و زمانی که این عدد از مرز ۱۰,۰۰۰ دلار عبور کند، این نشان ویژه به پروفایل شما تعلق می‌گیرد.",
  },
  // {
  //   title: "گواهی قهرمانی مسابقات ",
  //   infoText: (<p>این مدرک تایید می‌کند که مهارت شما در مقایسه با صدها یا هزاران معامله‌گر دیگر، در رتبه برتر قرار دارد. شما نه تنها سودده بوده‌اید، بلکه عملکردی فراتر از استاندارد و بهتر از رقبا داشته‌اید.<br/>کاربرد: یک مدرک عالی برای برندسازی شخصی و نشان دادن برتری تکنیکال شما نسبت به سایر فعالان بازار.</p>),
  //   howToText: "در مسابقات دوره‌ای تریدری کوژیتوفاند ثبت‌نام کنید. اگر در پایان زمان مسابقه، بالاترین درصد بازدهی را در میان شرکت‌کنندگان داشته باشید، این گواهی به نام شما صادر می‌شود.",
  // },
  // {
  //   title: "نشان عالی مدیریت ریسک ",
  //   infoText: (<p>برای یک شرکت سرمایه‌گذاری، «حفظ سرمایه» مهم‌تر از «کسب سود» است. این گواهی به معامله‌گرانی داده می‌شود که طی ۱۵ روز، با دقتی وسواس‌گونه تمامی حدود افت سرمایه را رعایت کرده‌اند و هیچ حرکت هیجانی انجام نداده‌اند.<br/>کاربرد: این مدرک به سرمایه‌گذاران ثابت می‌کند که پولشان در دست شما «امن» است.</p>),
  //   howToText: "به مدت ۱۵ روز متوالی در حساب خود فعال باشید و در این بازه، مدیریت سرمایه سخت‌گیرانه‌ای اعمال کنید (حفظ دراودان پایین و حجم‌های منطقی). سیستم هوشمند ما با رصد پارامترهای ریسک شما، این نشان را فعال می‌کند.",
  // },
  // {
  //   title: "تقدیرنامه ثبات و تعهد ",
  //   infoText: (<p>این گواهی به «رفتار حرفه‌ای» پاداش می‌دهد، نه صرفا به اعداد و ارقام. اگر شما ۱۰ روز معاملاتی متوالی، بدون نقض قوانین و با پایبندی کامل به برنامه معاملاتی خود عمل کنید، این نشان را دریافت می‌کنید.<br/>کاربرد: نشان‌دهنده دیسیپلین آهنین شماست و ثابت می‌کند که شما یک قمارباز نیستید، بلکه یک معامله‌گر با برنامه هستید.</p>),
  //   howToText: "برای دریافت این نشان، باید ۱۰ روز معاملاتی پی‌درپی (بدون وقفه) معامله کنید، بدون اینکه هیچ قانونی را بشکنید یا رفتارهای هیجانی (مثل باز کردن حجم‌های غیرمعمول) از خود نشان دهید.",
  // },
];

export const fallbackCardByType = cards.reduce((acc, card) => {
  acc[card.certificateType] = card;
  return acc;
}, {});

const EMPTY_CERTIFICATES = { gained: [], remained: [] };
const mergeCertificates = mergeBuckets(["gained", "remained"], (certificate) => certificate?.id ?? certificate?.uuid);

export default function CardsContainer() {
  const navigate = useNavigate();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showHowToModal, setShowHowToModal] = useState(false);
  const [infoModalData, setInfoModalData] = useState(null);
  const { data: certificates, initialLoading: isLoading, loadingMore, error, hasNext, sentinelRef, retry } = useInfinitePaginated({
    endpoint: `${API_BASE_URL}certificates/certificates`, navigate, initialData: EMPTY_CERTIFICATES,
    select: (response) => response.results || EMPTY_CERTIFICATES, merge: mergeCertificates,
  });

  const renderedCards = useMemo(() => {
    const gainedCards = certificates.gained.map((certificate) => {
      const fallbackCard =
        fallbackCardByType[certificate.certificate_type] || {};
      return {
        ...fallbackCard,
        ...certificate,
        key: `gained-${certificate.id}`,
        title: fallbackCard.title || certificate.certificate_type,
        imageSrc: certificate.file,
        downloadUrl: certificate.file,
        isBlured: true,
        isLock: false,
        isAchieved: true,
        isForExplanation: true,
      };
    });

    const remainedCards = certificates.remained.map((certificate) => {
      const fallbackCard =
        fallbackCardByType[certificate.certificate_type] || {};
      return {
        ...fallbackCard,
        ...certificate,
        key: `remained-${certificate.id}`,
        title: fallbackCard.title || certificate.certificate_type,
        imageSrc: certificate.bg_image,
        isBlured: true,
        isLock: true,
        isAchieved: false,
        isForExplanation: true,
      };
    });

    return [...gainedCards, ...remainedCards];
  }, [certificates]);

  return (
    <div className="relative w-full">
      <div className="w-full rounded-2xl p-5 grid grid-cols-1 lg:grid-cols-2 gap-12 justify-items-center bg-zi-bg2-light dark:bg-zi-bg2-dark">
        {isLoading && (
          <span className="col-span-full text-sm text-zi-text-light dark:text-zi-text-dark">
            در حال دریافت گواهی‌نامه‌ها...
          </span>
        )}

        {!isLoading &&
          renderedCards.map((item) => {
            return (
              <Card
                key={item.key}
                title={item.title}
                imageSrc={item.imageSrc}
                downloadUrl={item.downloadUrl}
                isBlured={item.isBlured}
                isLock={item.isLock}
                isAchieved={item.isAchieved}
                isForExplanation={item.isForExplanation}
                onHelp={() => {
                  setInfoModalData(item);
                  setShowInfoModal(true);
                }}
                onHowTo={() => {
                  setInfoModalData(item);
                  setShowHowToModal(true);
                }}
                onCardClick={
                  item.isAchieved
                    ? () => navigate("/certificate/for-you")
                    : undefined
                }
              />
            );
          })}
        {!isLoading && <InfiniteScrollFooter sentinelRef={sentinelRef} loading={loadingMore} error={error} onRetry={retry} hasNext={hasNext} />}
      </div>

      {showInfoModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowInfoModal(false)}
        >
          <div
            className="w-11/12 max-w-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <InfoModal
              title={infoModalData?.title}
              infoText={infoModalData?.infoText}
              onClose={() => {
                setShowInfoModal(false);
                setInfoModalData(null);
              }}
            />
          </div>
        </div>
      )}

      {showHowToModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setShowHowToModal(false)}
        >
          <div
            className="w-11/12 max-w-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <HowToModal
              title={infoModalData?.title}
              howToText={infoModalData?.howToText}
              onClose={() => setShowHowToModal(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
